import { Skeleton } from "@/components/shared/Skeleton";
import { CANVAS_SIZE } from "@/lib/constants/slides";

interface CanvasSkeletonProps {
  label?: string;
  canvasType?: "editor" | "freeform";
}

export function CanvasSkeleton({ label, canvasType = "editor" }: CanvasSkeletonProps) {
  const canvasSize = canvasType === "freeform" ? CANVAS_SIZE.freeform : CANVAS_SIZE.editor;

  return (
    <div
      className="relative bg-white shadow-lg overflow-hidden rounded-md flex items-center justify-center"
      style={{
        height: canvasSize.size.height,
        aspectRatio: canvasSize.aspectRatio,
      }}
    >
      {canvasType === "editor" ? (
        // Editor: Multiple layers for depth
        <>
          <Skeleton className="absolute inset-0 rounded-none opacity-30" />
          <Skeleton className="absolute inset-0 rounded-none opacity-20" />
        </>
      ) : (
        // Freeform: Single layer
        <Skeleton className="absolute inset-0 rounded-none opacity-50" />
      )}

      {label && (
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-xs font-medium text-slate-500 tracking-wide uppercase animate-pulse">
            {label}
          </span>
        </div>
      )}
    </div>
  );
}
